"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Thrown when attempting to publish a draft that contains errors
 * @param {string} courseId
 * @param {Array.<Object>} errors details on the publishing errors in the draft
 */
class PublishingErrors extends client_library_1.ExtendableError {
    constructor(courseId, errors) {
        super(`course: ${courseId} has publishing errors`);
        this.courseId = courseId;
        this.errors = errors;
    }
}
exports.default = PublishingErrors;
//# sourceMappingURL=PublishingErrors.js.map